import React, { useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAsyncValue, useNavigate } from 'react-router-dom';

// Constants
import { formActionValidationNaming } from '../../../../../components/forms/ActionForms/constants';

// Components
import BudgetItemsForm from '../../../../../components/forms/ActionForms/BudgetItemsForm';

// Types
import { BudgetItemsFormValues } from '../../../../../components/forms/ActionForms/BudgetItemsForm/types';
import { OrderActionReferences } from '../types';
import { Role } from '../../../../../types/auth';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

// Utils
import { roleCanViewBudgets } from '../../../../../utils/rolePermissions';

export default function BudgetItemsValidationFormPage(): JSX.Element | null {
  const { t } = useTranslation('validation');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as BudgetItemsFormValues &
    OrderActionReferences;
  const { user } = useAuth();
  const currentRole = user?.user?.rolActive as Role | undefined;

  // RoomTeam can only view, not edit
  const isReadOnly = currentRole === Role.RoomTeam;
  const skipBudgets =
    currentRole === Role.Tablet || !roleCanViewBudgets(currentRole);

  // Redirigir a Tablets y roles ciegos a budgets (capataz) al siguiente paso
  useLayoutEffect(() => {
    if (skipBudgets) {
      navigate('../materials', { replace: true });
      return;
    }

    if (loaderData.roid && loaderData.orderId) {
      dispatch(
        roidOTSelected('actions-validation', loaderData.roid, loaderData.orderId)
      );
    }
  }, [user, navigate, dispatch, loaderData]);

  const onFormSubmit = () => {
    if (isReadOnly) return; // RoomTeam cannot submit
    navigate('../materials');
  };

  // No renderizar para Tablets ni roles ciegos a budgets (capataz)
  if (skipBudgets) {
    return null;
  }

  return (
    <BudgetItemsForm
      onFormSubmit={isReadOnly ? () => {} : onFormSubmit}
      initialData={loaderData}
      sessionStorageKey={
        formActionValidationNaming.NEW_VALIDATION_BUDGET_ITEMS_FORM
      }
      updateKey={formActionValidationNaming.DATA_CHANGES}
      textButton={isReadOnly ? t('viewOnly') : t('validate')}
    />
  );
}
